import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Assets/Styles/Footer.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
const API_BASE_URL = "https://emailtool-backend-dev.protoneffect.net";
const adminEmails = ["tariq.qadri@protoneffect.com"];
const adminEmail = localStorage.getItem("adminEmail");

console.log("Logged-in Admin Email:", adminEmail);
const loggedInAdminEmail = localStorage.getItem("adminEmail");
const Admin = () => {
  const [users, setUsers] = useState([]);
  const [newEmail, setNewEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [editUserId, setEditUserId] = useState(null);
  const [editEmail, setEditEmail] = useState("");
  const [editPassword, setEditPassword] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [activeTab, setActiveTab] = useState("userList");
  const navigate = useNavigate();
  const [newPasswordError, setNewPasswordError] = useState("");
  const [editPasswordError, setEditPasswordError] = useState("");
  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    const role = localStorage.getItem("role");

    if (!token || role !== "admin") {
      navigate("/admin-login");
    } else {
      fetchUsers();
    }
  }, [navigate]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/users`);
      const data = await response.json();
      setUsers(data.users || []);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const createUser = async () => {
    if (!newEmail || !newPassword) {
      alert("All fields are required!");
      return;
    }

    if (!validatePassword(newPassword, setNewPasswordError)) {
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/users`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: newEmail, password: newPassword }),
      });

      if (response.ok) {
        setSuccessMessage("User created successfully!");
        setTimeout(() => setSuccessMessage(""), 3000);
        setNewEmail("");
        setNewPassword("");
        setNewPasswordError("");
        fetchUsers();
        setActiveTab("userList");
      }
    } catch (error) {
      console.error("Error creating user:", error);
    }
  };

  const suspendUser = async (userId) => {
    if (!userId) return;
    try {
      await fetch(`${API_BASE_URL}/users/${userId}/suspend`, {
        method: "PATCH",
      });
      fetchUsers();
    } catch (error) {
      console.error("Error suspending user:", error);
    }
  };

  const deleteUser = async (userId) => {
    if (!userId) return;
    try {
      await fetch(`${API_BASE_URL}/users/${userId}`, { method: "DELETE" });
      fetchUsers();
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const validatePassword = (password, setError) => {
    if (!password) {
      setError("");
      return false;
    }
    if (password.length < 5) {
      setError("Password must be at least 5 characters long!");
      return false;
    }
    setError("");
    return true;
  };

  const updateUser = async () => {
    if (!editUserId || !editEmail || !editPassword) {
      toast.error("All fields are required!");
      return;
    }

    if (!validatePassword(editPassword, setEditPasswordError)) {
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/users/${editUserId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: editEmail, password: editPassword }),
      });
      const result = await response.json();

      if (response.ok) {
        toast.success("User updated successfully!");

        document.getElementById("closeEditModal").click();
        document.body.classList.remove("modal-open");
        document.querySelector(".modal-backdrop")?.remove();

        if (editEmail === localStorage.getItem("adminEmail")) {
          setTimeout(() => {
            toast.info("Your credentials have changed. Please log in again.");
            handleLogout();
          }, 2000);
        } else {
          setEditUserId(null);
          setEditEmail("");
          setEditPassword("");
          setEditPasswordError("");
          fetchUsers();
        }
      } else {
        toast.error(`Error: ${result.message || "Failed to update user"}`);
      }
    } catch (error) {
      console.error("Error updating user:", error);
      toast.error("Something went wrong! Please try again.");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("role");
    navigate("/");
  };
  return (
    <div className="container mt-5">
      <ToastContainer />
      <div className="card shadow" style={{ width: "100%" }}>
        <div className="card-header text-center">
          <h3 className="mt-3">Admin Dashboard</h3>
        </div>
        {successMessage && (
          <div className="alert alert-success mt-3">{successMessage}</div>
        )}
        <ul className="nav nav-tabs mt-3">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "userList" ? "active" : ""}`}
              onClick={() => setActiveTab("userList")}
            >
              User List
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "addUser" ? "active" : ""}`}
              onClick={() => setActiveTab("addUser")}
            >
              Add User
            </button>
          </li>
        </ul>
        <div className="card-body">
          {activeTab === "userList" && (
            <div className="table-responsive">
              <table className="table table-striped">
                <thead className="table-dark">
                  <tr>
                    <th>Email</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user) => {
                    const isCurrentAdmin =
                      user.email === localStorage.getItem("adminEmail");

                    return (
                      <tr key={user.id}>
                        <td>{user.email}</td>
                        <td>{user.isSuspended ? "Suspended" : "Active"}</td>
                        <td>
                          <button
                            className="btn btn-warning btn-sm me-2"
                            onClick={() => {
                              if (isCurrentAdmin) {
                                toast.error("You cannot suspend yourself.");
                              } else {
                                suspendUser(user.id);
                              }
                            }}
                          >
                            {user.isSuspended ? "Unsuspend" : "Suspend"}
                          </button>

                          <button
                            className="btn btn-danger btn-sm me-2"
                            onClick={() => {
                              if (isCurrentAdmin) {
                                toast.error("You cannot delete yourself.");
                              } else {
                                deleteUser(user.id);
                              }
                            }}
                          >
                            Delete
                          </button>

                          <button
                            className="btn btn-primary btn-sm"
                            data-bs-toggle="modal"
                            data-bs-target="#editUserModal"
                            onClick={() => {
                              setEditUserId(user.id);
                              setEditEmail(user.email);
                            }}
                          >
                            Edit
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          {activeTab === "addUser" && (
            <div style={{ width: "40%", margin: "0 auto" }}>
              <div className="mb-3">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label>Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={newPassword}
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                    validatePassword(e.target.value, setNewPasswordError); 
                  }}
                />
                {newPasswordError && (
                  <p style={{ color: "red" }}>{newPasswordError}</p>
                )}
              </div>
              <button className="btn btn-success w-100" onClick={createUser}>
                Create User
              </button>
            </div>
          )}
        </div>
      </div>
      <div
        className="modal fade"
        id="editUserModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit User</h5>
              <button
                type="button"
                className="btn-close"
                id="closeEditModal"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              <input
                type="email"
                className="form-control mb-2"
                value={editEmail}
                onChange={(e) => setEditEmail(e.target.value)}
              />
              <input
                type="password"
                className="form-control mb-2"
                value={editPassword}
                onChange={(e) => {
                  setEditPassword(e.target.value);
                  validatePassword(e.target.value, setEditPasswordError); 
                }}
              />
              {editPasswordError && (
                <p style={{ color: "red" }}>{editPasswordError}</p>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={updateUser}>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Admin;
